import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router';

import { PolicyStatusTable } from './table';

export function PolicyStatus() {
	const nav = useNavigate();
	const tab = window.location.pathname.split('/').pop();
	return (
		<Tabs defaultValue="policy-status">
			<TabsList className="grid w-full grid-cols-2">
				<TabsTrigger value="policy-status">Policy Statuses</TabsTrigger>
				<TabsTrigger value="submission-status">Submission Statuses</TabsTrigger>
			</TabsList>
			<TabsContent value="policy-status">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle>Policy Statuses</CardTitle>
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<PolicyStatusTable isPolicyStatus={true} />
					</CardContent>
				</Card>
			</TabsContent>
			<TabsContent value="submission-status">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle className="mt-2">Submission Statuses</CardTitle>
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<PolicyStatusTable isPolicyStatus={false} />
					</CardContent>
				</Card>
			</TabsContent>
		</Tabs>
	);
}
